import { type FunctionalComponent, h, getAssetPath } from '@stencil/core';
import {FullWidthWidget} from '../../functional-components/offsites-widget-components';
import type {IWidgetData} from '../../offsites-widget-v4/types/offsites-widget-v4.types';
import {dummyBannerConfig} from './offsite-dummy-banner-config';
import {isMobile} from '../../../../../utils/media';
import type {labelProviderInterface} from '../../../../LabelProviderInterface';

interface IOffsitesDummyBanner {
  brand?: string
  country: string;
  language: string;
  tabName: string;
  isRtl: boolean;
  isDashboard: boolean;
  computedPlacement?: boolean;
  labelProvider?: labelProviderInterface;
}

export const OffsitesDummyBanner: FunctionalComponent<IOffsitesDummyBanner> = (props) => {
    const {brand, country, language, tabName, isRtl, isDashboard, computedPlacement, labelProvider} = props;
    const data: IWidgetData = dummyBannerConfig(brand, country, language, labelProvider);

    const imageSuffix = isMobile() ? '_small' : '';

    // const backgroundImagePath = getAssetPath(
  	// `assets/offsites-assets-v4/dummy_banner${imageSuffix}.jpg`
    // );
    const backgroundImagePath = `https://www.se.com/assets-search/assets/dummy_banner${imageSuffix}.jpg`;

    return <FullWidthWidget
      data={data}
      tabName={tabName}
      isDashboard={isDashboard}
      isRtl={isRtl}
      computedPlacement={computedPlacement}
      backgroundImagePath={backgroundImagePath}

    />;
};
